import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMealPlan = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "meal_plan",
	"data-name": "meal plan",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "11.04 20.59 1.5 20.59 1.5 1.5 16.77 1.5 16.77 9.14"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 4.36,
			y1: 5.32,
			x2: 6.27,
			y2: 5.32
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 8.18,
			y1: 5.32,
			x2: 13.91,
			y2: 5.32
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 4.36,
			y1: 9.14,
			x2: 6.27,
			y2: 9.14
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 8.18,
			y1: 9.14,
			x2: 13.91,
			y2: 9.14
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 4.36,
			y1: 12.95,
			x2: 6.27,
			y2: 12.95
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 8.18,
			y1: 12.95,
			x2: 13.91,
			y2: 12.95
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "plan2plate-icon",
			cx: 17.73,
			cy: 18.68,
			rx: 4.77,
			ry: 3.82
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M20.11,11h1.43a0,0,0,0,1,0,0v1.43a2.39,2.39,0,0,1-2.39,2.39H17.73a0,0,0,0,1,0,0V13.43A2.39,2.39,0,0,1,20.11,11Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M14.86,11.05h0a2.86,2.86,0,0,1,2.87,2.86v.95"
		})
	]
});
const ForwardRef = forwardRef(SvgMealPlan);
export default ForwardRef;
